import { __ } from "../../../utils/i18n.js";
function derivePaymentMethodDescriptor(paymentInformation) {
    const { paymentMethod, cardType, lastFourDigits } = paymentInformation ?? {};
    if (paymentMethod === "paypal" || paymentMethod === "PayPal") {
        return {
            network: "paypal",
            label: "PayPal",
            lastFour: lastFourDigits
        };
    }
    if (paymentMethod === "card") {
        switch(cardType){
            case "master":
                return {
                    network: "mastercard",
                    label: `${__("Mastercard")} ${__("credit card")}`,
                    lastFour: lastFourDigits
                };
            case "visa":
                return {
                    network: "visa",
                    label: `${__("VISA")} ${__("credit card")}`,
                    lastFour: lastFourDigits
                };
            case "american_express":
                return {
                    network: "amex",
                    label: `${__("American Express")} ${__("credit card")}`,
                    lastFour: lastFourDigits
                };
            case "maestro":
                return {
                    network: "maestro",
                    label: `${__("Maestro")} ${__("debit/credit card")}`,
                    lastFour: lastFourDigits
                };
            case "discover":
                return {
                    network: "unknown",
                    label: `${__("Discover Card")} ${__("credit card")}`,
                    lastFour: lastFourDigits
                };
            case "jcb":
                return {
                    network: "unknown",
                    label: `${__("JCB")} ${__("credit card")}`,
                    lastFour: lastFourDigits
                };
            case "diners_club":
                return {
                    network: "unknown",
                    label: `${__("Diners Club")} ${__("credit card")}`,
                    lastFour: lastFourDigits
                };
            case "unionpay":
                return {
                    network: "unknown",
                    label: `${__("China UnionPay")} ${__("credit card")}`,
                    lastFour: lastFourDigits
                };
            default:
                return {
                    network: "unknown",
                    label: __("an unknown credit card"),
                    lastFour: lastFourDigits
                };
        }
    }
    return {
        network: "unknown",
        label: __("Unknown"),
        lastFour: undefined
    };
}
export { derivePaymentMethodDescriptor };
